import { render } from "./RequestReceived.vue?vue&type=template&id=379920ea&scoped=true"
import script from "./RequestReceived.vue?vue&type=script&lang=js"
export * from "./RequestReceived.vue?vue&type=script&lang=js"

import "./RequestReceived.vue?vue&type=style&index=0&id=379920ea&scoped=true&lang=css"

import exportComponent from "D:\\vue-js\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379920ea"]])

export default __exports__